import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const NoInterviewQuestions = () => {
    const { t } = useTranslation();

    return (
        <Box sx={{ p: 2, textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
                {t('jobApplicationPage.noInterviewQuestionsAvailable')}
            </Typography>
        </Box>
    );
};

export default NoInterviewQuestions;
